import Vue from "vue";
import vSelect from "vue-select";
import { Component, Model, Prop } from "vue-property-decorator";
import axios from "axios";

import { IGraphUser } from "@/models";
import { authService } from "@/services";

@Component({
    name: "people-picker",
    components: {
        "v-select": vSelect,
    },
})
export default class PeoplePicker extends Vue {

    @Model("input", { required: false, default: () => [] })
    public selectedUsers: IGraphUser[];

    @Prop({ required: false, default: false })
    public multiple: boolean;

    @Prop({ required: false, default: false })
    public placeHolder: string;

    public adUsers: IGraphUser[] = [];

    public get internalSelectedUsers(): IGraphUser[] {
        return this.selectedUsers;
    }

    public set internalSelectedUsers(value: IGraphUser[]) {
        // Reset filter
        this.adUsers = [];

        this.$emit("input", value);
    }

    public usersPromise: Promise<any>;

    constructor() {
        super();

        this.usersPromise = null;
    }

    public async searchADUsers(search: string, loading: (loading: boolean) => void): Promise<void> {
        try {
            loading(true);

            if (search.length >= 2) {
                const queryConfig = {
                    baseURL: window.location.origin,
                    params: {
                        prefix: search,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${await authService.getAccessToken()}`,
                    },
                    timeout: 5000,
                };

                const response = await axios.get<IGraphUser[]>(process.env.VUE_APP_AZURE_FUNCTION_BASE_URL + "/Graph/GetUsersByPrefix", queryConfig);
                if (response.status === 200) {
                    this.adUsers = response.data;
                }
            }

        } catch (error) {
            this.adUsers = [];
        } finally {
            loading(false);
        }
    }
}
